export enum RewardType {
  PercentageDiscountCoupon = 1,
  ValueDiscountCoupon = 2
}